export class SessionService {
  static readonly sessionName = 'NOA_HUB_FROM';

  public static set FromSession(from: string) {
    sessionStorage.setItem(this.sessionName, from);
  }

  public static get FromSession() {
    return sessionStorage.getItem(this.sessionName) || '';
  }

  public static RemoveFromSession() {
    sessionStorage.removeItem(this.sessionName);
  }
}
